import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import {
  setCellularServicesOpt1,
  setCellularServicesOpt2,
  setCellularServicesOpt3,
  setCellularServicesOpt4,
  setCellularServicesOpt5,
  savedCellularServices,
  onCloseCellularServices,
} from './ChooseCellularServicesSlice';
import {reportAnalytics} from '../saleBlockSlice';
import {connect} from 'react-redux';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';

const chooseCellularServices = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
    }
  }, []);

  function saved() {
    props.savedCellularServices();
    props.reportAnalytics({
      eventCategory: 'cellular_newsale_process',
      eventAction: props.flowType == 'existsCustomer' ? 'click_18' : 'click_39',
      eventLabel: props.productsInfo.selectedProducts[0]?.name,
    });
    props.onClose();
  }

  function close() {
    props.reportAnalytics({
      eventCategory: 'cellular_newsale_process',
      eventAction: 'click_19',
      eventLabel: props.productsInfo.selectedProducts[0]?.name,
    });
    props.onCloseCellularServices();
    props.onClose();
  }

  return (
    <PopUp showPopUp={props.showPopUp} onClose={() => close()} className='popup-choose-cellular-services'>
      <div className='choose-cellular-services'>
        <Row>
          <Col ms={12}>
            <h1 className='top-title'>{props.subTitle}</h1>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <p className='top-link'>{props.linkText}</p>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <div className='component-container'>
              <p>שירות תוכן ו/או מידע בתשלום חד פעמי</p>
              <ul className='list'>
                <li>
                  {' '}
                  א. קבלת או הורדת תוכן באמצעות האינטרנט ,צפייה בו ו/או האזנה לו באופן חד פעמי (כגון : הורדה או צפייה בסרט וידאו, האזנה
                  לשיר, הורדת רינגטון, הורדת סרט וידאו, הורדת משחק והכול באופן חד פעמי).
                </li>
                <li>
                  ב. שליחת מסרון בתשלום מיוחד לשם הצבעה במסגרת תוכנית המשודרת בטלוויזיה באופן חד פעמי (כגון:הצבעה לתוכנית ריאליטי, באופן חד
                  פעמי).
                </li>
                <li>ג. מתן תרומה באמצעות שליחת מסרון באופן חד פעמי (כגון: תרומה לאגודה באופן חד פעמי).</li>
                <li>
                  ד. קבלת מידע שימושי באופן חד פעמי ( כגון:מידע על קווי תחבורה,בעלי מקצוע,מידע פיננסי, הודעה בעניין קבלת דבר דואר רשום והכול
                  באופן חד פעמי).
                </li>
                <li>
                  ה. קבלת תוכן באופן חד פעמי ( כגון: חידון, הגרלה, סקר, משאל, תחזית אסטרולוגית ,קבלת קישור להורדת סרטון וידו והכל באופן חד
                  פעמי ).
                </li>
              </ul>
              <Row>
                <Col ms={6} xs={6}>
                  <div className='btn-container-right'>
                    <div className='btn-additional-number'>
                      <button
                        onClick={(e) => props.setCellularServicesOpt1(false)}
                        className={
                          !props.cellularServices.isCellularServicesOpt1
                            ? 'btn-additional-number__body selected'
                            : 'btn-additional-number__body unselected'
                        }>
                        <span className='btn-additional-number__text'>חסום</span>
                      </button>
                    </div>
                  </div>
                </Col>
                <Col ms={6} xs={6}>
                  <div className='btn-container-left'>
                    <div className='btn-additional-number'>
                      <button
                        onClick={(e) => props.setCellularServicesOpt1(true)}
                        className={
                          props.cellularServices.isCellularServicesOpt1
                            ? 'btn-additional-number__body selected'
                            : 'btn-additional-number__body unselected'
                        }>
                        <span className='btn-additional-number__text'>פתוח</span>
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        <Row>
          <Col ms={12}>
            <br />
            <div className='component-container'>
              <p>שירות תוכן ו/או מידע בתשלום מתמשך- מנוי</p>
              <ul className='list'>
                <li>
                  א. קבלת או הורדת תוכן באמצעות האינטרנט צפייה בו ו/או האזנה לו שלא באופן חד פעמי (כגון מנוי להורדה או צפייה בסרט וידיאו,
                  מנוי לשירות מוזיקה, מנוי להורדת רינגטונים, מנוי להורדת סרטי וידאו ומנוי להורדת משחקים).
                </li>
                <li>
                  ב. קבלת תוכן ו/או מידע שלא באופן חד פעמי (כגון: מנוי לקבלת עדכוני חדשות, מנוי לקבלת תוצאות ספורט ,מנוי לקבלת שאלות טריוויה
                  ,מנוי לקבלת מתכוני דיאטה).
                </li>
              </ul>
              <Row>
                <Col ms={6} xs={6}>
                  <div className='btn-container-right'>
                    <div className='btn-additional-number'>
                      <button
                        onClick={(e) => props.setCellularServicesOpt2(false)}
                        className={
                          !props.cellularServices.isCellularServicesOpt2
                            ? 'btn-additional-number__body selected'
                            : 'btn-additional-number__body unselected'
                        }>
                        <span className='btn-additional-number__text'>חסום</span>
                      </button>
                    </div>
                  </div>
                </Col>
                <Col ms={6} xs={6}>
                  <div className='btn-container-left'>
                    <div className='btn-additional-number'>
                      <button
                        onClick={(e) => props.setCellularServicesOpt2(true)}
                        className={
                          props.cellularServices.isCellularServicesOpt2
                            ? 'btn-additional-number__body selected'
                            : 'btn-additional-number__body unselected'
                        }>
                        <span className='btn-additional-number__text'>פתוח</span>
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col ms={12}>
            <div className='component-container'>
              <p>גישה לשירות פרימיום</p>
              <ul className='list'>
                <li>
                  הכולל השמעת תוכן קולי או הצגת תוכן חזותי, כגון: מידע, בידור, ייעוץ, שירות היכרויות, השתתפות בתחרויות וכו', הניתן באמצעות
                  חיוג למספר הכולל את קידומות החיוג 1-900 ו 1-901
                </li>
                <li>א. מספרים בקידומת 1-900 בתעריף של עד 50 אג' לדקה ולא יותר מ- 30 ₪ לשיחה כולה.</li>
                <li>ב. מספרים בקידומת 1-901 בתעריף שאינו עולה על 50 ₪ לשיחה כולה.</li>
              </ul>
              <Row>
                <Col ms={6} xs={6}>
                  <div className='btn-container-right'>
                    <div className='btn-additional-number'>
                      <button
                        onClick={(e) => props.setCellularServicesOpt3(false)}
                        className={
                          !props.cellularServices.isCellularServicesOpt3
                            ? 'btn-additional-number__body selected'
                            : 'btn-additional-number__body unselected'
                        }>
                        <span className='btn-additional-number__text'>חסום</span>
                      </button>
                    </div>
                  </div>
                </Col>
                <Col ms={6} xs={6}>
                  <div className='btn-container-left'>
                    <div className='btn-additional-number'>
                      <button
                        onClick={(e) => props.setCellularServicesOpt3(true)}
                        className={
                          props.cellularServices.isCellularServicesOpt3
                            ? 'btn-additional-number__body selected'
                            : 'btn-additional-number__body unselected'
                        }>
                        <span className='btn-additional-number__text'>פתוח</span>
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col ms={12}>
            <div className='component-container'>
              <p>שירות שיחות לחו"ל</p>
              <Row>
                <Col ms={6} xs={6}>
                  <div className='btn-container-right'>
                    <div className='btn-additional-number'>
                      <button
                        onClick={(e) => props.setCellularServicesOpt4(false)}
                        className={
                          !props.cellularServices.isCellularServicesOpt4
                            ? 'btn-additional-number__body selected'
                            : 'btn-additional-number__body unselected'
                        }>
                        <span className='btn-additional-number__text'>חסום</span>
                      </button>
                    </div>
                  </div>
                </Col>
                <Col ms={6} xs={6}>
                  <div className='btn-container-left'>
                    <div className='btn-additional-number'>
                      <button
                        onClick={(e) => props.setCellularServicesOpt4(true)}
                        className={
                          props.cellularServices.isCellularServicesOpt4
                            ? 'btn-additional-number__body selected'
                            : 'btn-additional-number__body unselected'
                        }>
                        <span className='btn-additional-number__text'>פתוח</span>
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col ms={12}>
            <div className='component-container'>
              <p>פרסום ב-144</p>
              <ul className='list'>
                <li>פרסום מספר/י הטלפון המחויב/ים בחשבון , במודיעין הטלפוני (" 144 ") ובאינטרנט. </li>
              </ul>
              <Row>
                <Col ms={6} xs={6}>
                  <div className='btn-container-right'>
                    <div className='btn-additional-number'>
                      <button
                        onClick={(e) => props.setCellularServicesOpt5(false)}
                        className={
                          !props.cellularServices.isCellularServicesOpt5
                            ? 'btn-additional-number__body selected'
                            : 'btn-additional-number__body unselected'
                        }>
                        <span className='btn-additional-number__text'>חסום</span>
                      </button>
                    </div>
                  </div>
                </Col>
                <Col ms={6} xs={6}>
                  <div className='btn-container-left'>
                    <div className='btn-additional-number'>
                      <button
                        onClick={(e) => props.setCellularServicesOpt5(true)}
                        className={
                          props.cellularServices.isCellularServicesOpt5
                            ? 'btn-additional-number__body selected'
                            : 'btn-additional-number__body unselected'
                        }>
                        <span className='btn-additional-number__text'>פתוח</span>
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <Row>
          <div className='btn-wrapper col-12'>
            <BtnSubmit onclick={() => saved()} text='שמור הגדרות והמשך' formid='choose-cellular-services-btn'></BtnSubmit>
          </div>
        </Row>
      </div>
    </PopUp>
  );
};
const mapStateToProps = (state) => {
  return {cellularServices: state.chooseCellularServices, productsInfo: state.saleBlock.productsInfo, flowType: state.saleBlock.flowType};
};

const mapDispatchToProps = {
  setCellularServicesOpt1,
  setCellularServicesOpt2,
  setCellularServicesOpt3,
  setCellularServicesOpt4,
  setCellularServicesOpt5,
  savedCellularServices,
  onCloseCellularServices,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(chooseCellularServices);
